import { isFieldError } from "../helpers";

import Input from "../components/Input";
import RadiosScale from "../components/RadiosScale";

export default function Q6Fields({ handleUpdate, errors, q6_3 }) {
	return (
		<>
			<h4 style={{ fontSize: "1.15rem" }}>6. Ticketing Process</h4>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="6.1 How easy was it to manage and distribute tickets for your attendees?"
					reqd={true}
					data={[
						{
							name: "q6_1",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q6_1",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q6_1",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q6_1",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q6_1",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q6_1") ? true : false}
				/>
			</div>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="6.2 How clear were ticketing rules, deadlines, and usage instructions?"
					reqd={true}
					data={[
						{
							name: "q6_2",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q6_2",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q6_2",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q6_2",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q6_2",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q6_2") ? true : false}
				/>
			</div>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="6.3 Did you encounter any ticketing issues that required escalation or support?"
					reqd={true}
					data={[
						{
							name: "q6_3",
							val: "Yes",
							label: "Yes",
						},
						{
							name: "q6_3",
							val: "No",
							label: "No",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q6_3") ? true : false}
				/>
			</div>

			{q6_3 === "Yes" && (
				<div className="form-group one indent" style={{ marginTop: "0px" }}>
					<Input
						name="q6_3a"
						label="Please describe:"
						reqd={true}
						value={""}
						autocomplete="off"
						update={handleUpdate}
						errors={errors}
					/>
				</div>
			)}

			<div className="form-group one " style={{ marginTop: "15px" }}>
				<Input
					name="q6_4"
					label="6.4 What changes would most improve the ticketing experience?"
					reqd={true}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>
		</>
	);
}
